// extracted by mini-css-extract-plugin
export default {"main_wrapper":"PressReleasePage_main_wrapper__gklF5","body":"PressReleasePage_body__0Ie7U"};